import React from 'react';
import {
    Drawer, Button, Radio, Icon,
    Result, Card,
    Typography, Tag, Spin, Divider
} from 'antd';
// console.log(blogConfig)
const { Meta } = Card;


export class Layer extends React.Component {
    /**
     * A layer will be a part of a Canvas. This is where you will draw shit
     * @param {T} props 
     */
    constructor(props) {
        super(props);
        this.state={
          visibility:this.props.visibility
        }
    }

    componentDidMount() {
        // Here we set up the properties of the canvas element. 
        this.canvas.width = this.props.width;
        this.canvas.height = this.props.height;
        this.canvas.id = this.props.name

      }
    
      componentDidUpdate(prevProps){
        if(prevProps.visibility !== this.props.visibility){
          this.setState({          
            visibility: this.props.visibility
          });
        }

        // This will make sure that right components are being used while drawing
        if(prevProps.name !== this.props.name){
          this.canvas.id = this.props.name
        }
      }


    render() {
      // console.log(this.props.visibility)
        return (
            <canvas
          // We use the ref attribute to get direct access to the canvas element. 
            ref={(ref) => (this.canvas = ref)}
            style={{ background: this.props.isBase?'white':null, //remove later and change to null instead of green
                                      position:'absolute', 
                                      marginLeft:-this.props.width/2, 
                                      marginTop:-this.props.height/2,
                                    visibility:this.state.visibility?'visible':'hidden',
                                    boxShadow: this.props.isBase?'0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)':null}}
            
          />
        );
    }
};